import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { ApiService } from './api.service';
import { CommonService } from './common.service';

const route = {
  send: '/feedback/send',
  filter: '/feedback/filter',
  getById: (id) => `/feedback/get-by-id/${id}`,
  downloadFile: (id: string) => `/file/download/feedback/${id}`
}

@Injectable({
  providedIn: 'root'
})
export class AsReflectionService {

  constructor(private apiService: ApiService, private commonService: CommonService) { }

  // send feedback
  feedback(typeId, title, content, files: File[] = []) {
    const formData = new FormData();
    formData.append('itemTypeId', typeId);
    formData.append('title', title);
    formData.append('contentFeedback', content);

    for (let file of files) {
      formData.append('file', file);
    }

    return this.apiService.postUpload(route.send, formData).pipe(
      map(res => {
        return res;
      })
    )
  }

  /**
   * Version Base64 cua feedback - file anh dinh kem gui JSON thay multipart binary.
   */
  feedbackBase64 = async (typeId, title, content, files: File[] = []) => {
    const listFileBase64 = await Promise.all(files.map(async file => ({
      fileName: file.name,
      file: await this.commonService.getFileBase64(file)
    })));
    return this.apiService.postFileBase64(route.send, {
      itemTypeId: typeId,
      title,
      contentFeedback: content,
      files: listFileBase64
    }).pipe(
      map(res => {
        return res;
      })
    ).toPromise();
  }

  filterFeedback(form) {
    return this.apiService.post(route.filter, form).pipe(
      map(res => {
        return res;
      })
    )
  }

  getById(id) {
    return this.apiService.get(route.getById(id)).pipe(
      map(res => {
        return res;
      })
    )
  }

  downloadFile(fileId: string) {
    return this.apiService.getFile(route.downloadFile(fileId)).pipe(
      map(res => {
        return res
      })
    )
  }
}
